document.addEventListener('DOMContentLoaded', function () {
	const container = document.querySelector('.txt__wrapper');
	const loader = document.querySelector('.txt__loader');
	const message = document.querySelector('.txt__message');

	let currentPage = 1;
	let hasMorePages = true;
	let isLoading = false;

	let singleModal = null;
	let archiveUrl = window.location.href;

	function showLoader() {
		if (!loader) return;
		loader.innerHTML = `<div class="loader-spinner"><div></div><div></div><div></div><div></div></div>`;
		loader.style.display = 'flex';
	}

	function hideLoader() {
		if (!loader) return;
		loader.style.display = 'none';
		loader.innerHTML = '';
	}

	function createMessage(text) {
		if (!message) return;
		message.textContent = text;
		message.style.display = 'block';
	}

	function removeMessage() {
		if (!message) return;
		message.style.display = 'none';
		message.textContent = '';
	}

	function createCard(post, index) {
		const title = post.title.rendered || '';
		const permalink = post.link || '';
		const slug = post.slug;
		const delay = (index * 0.1).toFixed(1);

		const html = `
			<div class="txt__wrapper-item wow animate__animated animate__fadeInUp" data-wow-delay="${delay}s">
				<a href="${permalink}" data-slug="${slug}">
					<h2 class="txt-title">${title}</h2>
				</a>
			</div>
		`;

		const wrapper = document.createElement('div');
		wrapper.innerHTML = html.trim();
		return wrapper.firstChild;
	}

	function loadTexts() {
		if (isLoading || !hasMorePages) return;
		isLoading = true;
		removeMessage();
		showLoader();

		const apiUrl = `${somaData.siteURL}/wp-json/wp/v2/txt?page=${currentPage}&per_page=10&lang=${somaData.lang}`;

		fetch(apiUrl)
			.then(res => {
				if (!res.ok) {
					if (res.status === 400) {
						hasMorePages = false;
						return [];
					}
					throw new Error('Erro API');
				}
				return res.json();
			})
			.then(data => {
				if (!data.length) {
					if (currentPage === 1) createMessage('Nenhum texto encontrado.');
					hasMorePages = false;
					return;
				}
				data.forEach((post, index) => {
					container.appendChild(createCard(post, index));
				});
				currentPage++;
			})
			.catch(err => {
				if (currentPage === 1) createMessage('Erro ao carregar textos');
				console.error(err);
			})
			.finally(() => {
				isLoading = false;
				hideLoader();
			});
	}

	function createSingleModal() {

		if (singleModal) return;

		singleModal = document.createElement('section');
		singleModal.className = 'single-txt';
		singleModal.innerHTML = `
			<div class="center">
				<div class="single-txt__container">

					<div class="single-txt__container-close">
						<span aria-hidden="true">X</span>
					</div>

					<article class="single-txt__item">
						<div class="single-txt__container-info"></div>
					</article>

				</div>
			</div>
		`;

		document.body.appendChild(singleModal);

		singleModal.querySelector('.single-txt__container-close')
			.addEventListener('click', closeSingleModal);
	}

	function openSingleModal() {

		if (singleModal) return;

		createSingleModal();

		document.body.classList.add('is-single-txt-open');
		document.body.style.overflow = 'hidden';
	}

	function closeSingleModal(fromPopState = false) {

		if (!singleModal) return;

		document.body.classList.remove('is-single-txt-open');
		document.body.style.overflow = '';

		singleModal.classList.add('is-closing');

		setTimeout(() => {

			if (!singleModal) return;

			singleModal.remove();
			singleModal = null;

			if (!fromPopState) {
				history.pushState({}, '', archiveUrl);
			}

		}, 350);
	}

	function loadSingleTxt(slug) {

		openSingleModal();

		const info = singleModal.querySelector('.single-txt__container-info');

		info.innerHTML = `
			<div class="single-txt__loader is-active">
				<div class="loader-spinner"><div></div><div></div><div></div><div></div></div>
			</div>
		`;

		const apiUrl = `${somaData.siteURL}/wp-json/wp/v2/txt?slug=${slug}&_embed&lang=${somaData.lang}`;

		fetch(apiUrl)
			.then(res => res.json())
			.then(posts => {

				if (!posts.length) {
					info.innerHTML = `<p>Texto não encontrado.</p>`;
					return;
				}

				const post = posts[0];

				const year = post.acf?.txt_year || '';
				const author = post.acf?.txt_author || '';

				info.innerHTML = `
					<header class="single-txt__container-info-heading">
						${year ? `<span>${year}</span>` : ''}
						<h1>${post.title.rendered}</h1>
						${author ? `<span>${author}</span>` : ''}
					</header>

					<div class="single-txt__container-info-content">
						${post.content.rendered}
					</div>
				`;

				history.pushState({ modal: true }, '', post.link);
			})
			.catch(err => {

				info.innerHTML = `<p>Erro ao carregar o texto.</p>`;
				console.error(err);
			});
	}

	document.addEventListener('click', function (e) {

		const link = e.target.closest('.txt__wrapper-item a');

		if (link) {
			e.preventDefault();
			loadSingleTxt(link.dataset.slug);
		}
	});

	window.addEventListener('popstate', function () {
		if (singleModal) {
			closeSingleModal(true);
		}
	});

	window.addEventListener('scroll', function () {

		if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500) {
			loadTexts();
		}
	});

	loadTexts();
});